<template>
  <div class="m-confirm">
    <m-dialog
      v-model:value="showConfirm"
      :max-width="$modalSizes.sm"
      :title="title"
      :fullscreen-on-mobile="false"
      hide-header
      hide-footer
      fade-in
      center
      @close="close"
    >
      <div class="_heading">
        {{ title }}
      </div>
      <div class="_actions">
        <div class="_confirm">
          <m-btn
            :color="okType"
            :large="$store.state.breakpoint.smAndDown"
            :loading="okLoading"
            block
            tabindex="0"
            :outlined="okType !== 'primary'"
            @click="submit"
          >
            {{ okText }}
          </m-btn>
        </div>
        <div class="_cancel">
          <m-btn
            v-if="!hideCancel"
            :color="cancelType"
            :large="$store.state.breakpoint.smAndDown"
            :loading="cancelLoading"
            outlined
            block
            tabindex="0"
            @click="cancel"
          >
            {{ cancelText }}
          </m-btn>
        </div>
      </div>
    </m-dialog>
  </div>
</template>

<script>

export default {
  name: 'MConfirm',
  props: {
    eventBus: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  data() {
    return {
      showConfirm: false,
      title: '',
      okText: '',
      okType: '',
      cancelText: '',
      cancelType: '',
      hideCancel: false,
      okLoading: false,
      cancelLoading: false,
      hideOnSubmit: true,
      hideOnCancel: true,
      onCancel: () => {
      },
      onOk: () => {
      },
    };
  },
  methods: {
    submit() {
      if (this.hideCancel) {
        this.showConfirm = false;
        return;
      }

      this.onOk(this.setOkLoading);

      if (this.hideOnSubmit) {
        this.showConfirm = false;
      }
    },
    cancel() {
      this.onCancel(this.setCancelLoading);
      if (this.hideOnCancel) {
        this.showConfirm = false;
      }
    },
    setOkLoading(value) {
      this.okLoading = value;
    },
    setCancelLoading(value) {
      this.cancelLoading = value;
    },
    show({
      title,
      okText = this.$t('general.okay'),
      cancelText = this.$t('general.cancel'),
      onOk = () => ({}),
      okType = 'primary',
      cancelType = 'default',
      hideCancel = false,
      hideOnSubmit = true,
      hideOnCancel = true,
      onCancel = () => ({}),
    }) {
      this.title = title;
      this.okText = okText;
      this.cancelText = cancelText;
      this.okType = okType;
      this.cancelType = cancelType;
      this.onOk = onOk;
      this.hideCancel = hideCancel;
      this.hideOnCancel = hideOnCancel;
      this.hideOnSubmit = hideOnSubmit;
      this.onCancel = onCancel;
      this.showConfirm = true;
    },
    hide() {
      this.showConfirm = false;
    },
    close() {
      this.cancelLoading = false;
      this.okLoading = false;
      this.$emit('close');
    },
  },
  created() {
    this.eventBus.$on('show-confirm', this.show);
    this.eventBus.$on('hide-confirm', this.hide);
  },
  beforeUnmount() {
    this.eventBus.$off('show-confirm', this.show);
    this.eventBus.$off('hide-confirm', this.hide);
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  ._heading {
    margin-bottom: 2rem;
    font-size: $font-size-5;
  }

  ._actions {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    ._cancel {
      margin-top: 1.2rem;
    }
  }
</style>
